interface IConfiguration {
	maxLengthDepotHeader: number;
	maxLinesDepotHeader: number;
	maxLengthLabel: number;
	maxLengthAccessPoint: number;
	minLengthAccessPoint: number;
	maxLengthDescription: number;
	maxLengthExpoMetadataTitleDisplay: number;
	maxLengthExpoMetadataDescriptionDisplay: number;
	maxLengthExpoEndpointMetadataTitleDisplay: number;
	maxLengthExpoEndpointMetadataDetailsDisplay: number;
	maxLengthSubMetadataTitleDisplay: number;
	maxLengthSubMetadataDescriptionDisplay: number;
	maxLengthSubPublicMetadataTitleDisplay: number;
	maxLengthSubPublicMetadataDescriptionDisplay: number;
	maxLengthProjectEmailTitle: number;
	maxLengthProjectEmailMessage: number;
	maxLinesProjectEmailMessage: number;
}

export const configuration: IConfiguration = {
	maxLengthDepotHeader: 40,
	maxLinesDepotHeader: 1,
	maxLengthLabel: 255,
	maxLengthAccessPoint: 50,
	minLengthAccessPoint: 4,
	maxLengthDescription: 2500,
	maxLengthExpoMetadataTitleDisplay: 50,
	maxLengthExpoMetadataDescriptionDisplay: 250,
	maxLengthExpoEndpointMetadataTitleDisplay: 120,
	maxLengthExpoEndpointMetadataDetailsDisplay: 400,
	maxLengthSubMetadataTitleDisplay: 150,
	maxLengthSubMetadataDescriptionDisplay: 450,
	maxLengthSubPublicMetadataTitleDisplay: 50,
	maxLengthSubPublicMetadataDescriptionDisplay: 450,
	maxLengthProjectEmailTitle: 256,
	maxLengthProjectEmailMessage: 2500,
	maxLinesProjectEmailMessage: 10,
};
